var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIconsWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2333 9.03464L8.552 1.50234C8.18013 0.999219 7.61138 0.714844 6.99888 0.714844C6.3645 0.714844 5.79575 0.999219 5.44575 1.50234L0.764501 9.03464C0.327001 9.62526 0.261376 10.3909 0.589501 11.0471C0.917626 11.7034 1.57388 12.119 2.31763 12.119H11.6801C12.4239 12.119 13.0801 11.7034 13.4083 11.0471C13.7364 10.4128 13.6708 9.62526 13.2333 9.03464ZM12.5333 10.6096C12.3583 10.9378 12.052 11.1346 11.6801 11.1346H2.31763C1.94575 11.1346 1.6395 10.9378 1.4645 10.6096C1.31138 10.2815 1.33325 9.90964 1.552 9.62526L6.23325 2.09297C6.40825 1.85234 6.69263 1.69922 6.99888 1.69922C7.30513 1.69922 7.5895 1.83047 7.7645 2.09297L12.4458 9.62526C12.6645 9.90964 12.6864 10.2815 12.5333 10.6096Z",
    fill: "#FF7F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99531 4.7832C6.73281 4.7832 6.49219 5.00195 6.49219 5.28633V7.6707C6.49219 7.9332 6.71094 8.17383 6.99531 8.17383C7.27969 8.17383 7.49844 7.95508 7.49844 7.6707V5.26445C7.49844 5.00195 7.25781 4.7832 6.99531 4.7832Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99531 8.75C6.73281 8.75 6.49219 8.96875 6.49219 9.25312V9.3625C6.49219 9.625 6.71094 9.86563 6.99531 9.86563C7.27969 9.86563 7.49844 9.64687 7.49844 9.3625V9.23125C7.49844 8.96875 7.25781 8.75 6.99531 8.75Z",
    fill: "#FF7F50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIconsWarning);
export default __webpack_public_path__ + "static/media/tag-icons-warning.8e67d0f1f0155c11c6534a637ad6bee3.svg";
export { ForwardRef as ReactComponent };